export default __webpack_public_path__ + "static/media/cameraOff.a61d4a02.svg";